var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"riclothes-logo",class:{ dark: this.$root.config.isDarkTheme},attrs:{"src":require("../assets/logo/logo_empty.svg")}})}
var staticRenderFns = []

export { render, staticRenderFns }